import { POSTHOG_TRACKING_EVENTS, PosthogTrackingSource } from '../constants';
import { CaptureTrackingEvent } from './types';

export const createThemeEvents = (
  captureTrackingEvent: CaptureTrackingEvent
) => {
  const trackThemeOpen = (source: PosthogTrackingSource) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.THEME_OPEN,
      properties: { source },
    });

  const trackThemeOverviewDrawerOpen = (source: PosthogTrackingSource) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.THEME_OVERVIEW_DRAWER_OPEN,
      properties: { source },
    });

  const trackThemePerformanceWidgetTabSelected = (
    source: PosthogTrackingSource,
    type: string
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.THEME_PERFORMANCE_WIDGET_TAB_SELECTED,
      properties: { source, type },
    });

  return {
    trackThemeOpen,
    trackThemeOverviewDrawerOpen,
    trackThemePerformanceWidgetTabSelected,
  };
};
